export const GET_CONNECTIONS = 'GET_CONNECTIONS';
export const FAV_CONNECTIONS = 'FAV_CONNECTIONS';
export const SET_CONNECTIONS = 'SET_CONNECTIONS';
export const CLEAR_CONNECTIONS = 'CLEAR_CONNECTIONS';
export const REMOVE_CONNECTIONS = 'REMOVE_CONNECTIONS';
